import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from './contexts/AuthContext'
import LoginPage from './pages/LoginPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import UpdatePasswordPage from './pages/UpdatePasswordPage'
import AdminDashboard from './pages/AdminDashboard'
import CustomerDashboard from './pages/CustomerDashboard'
import CustomerManagementPage from './pages/CustomerManagementPage'
import CustomerDataEntryPage from './pages/CustomerDataEntryPage'
import CustomerWeeklyDataEntryPage from './pages/CustomerWeeklyDataEntryPage'
import CustomerDailyDataEntryPage from './pages/CustomerDailyDataEntryPage'
import CustomerProfilePage from './pages/CustomerProfilePage'
import AdminAnalyticsDashboard from './components/AdminAnalyticsDashboard'
import About from './components/About'
import Footer from './components/Footer'
import AIChatWidget from './components/AIChatWidget'

function App() {
  const { user, userRole, loading } = useAuth()
  const { t } = useTranslation('common')

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">{t('status.loading')}</div>
      </div>
    )
  }

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <main className="flex-1">
          <Routes>
            <Route 
              path="/login" 
              element={!user ? <LoginPage /> : <Navigate to="/dashboard" />} 
            />
            <Route
              path="/forgot-password"
              element={!user ? <ForgotPasswordPage /> : <Navigate to="/dashboard" />}
            />
            <Route path="/update-password" element={<UpdatePasswordPage />} />
            <Route path="/about" element={<About />} />
            <Route 
              path="/dashboard" 
              element={
                user ? (
                  userRole === 'admin' ? <AdminDashboard /> : <CustomerDashboard />
                ) : (
                  <Navigate to="/login" />
                )
              } 
            />
            <Route 
              path="/admin" 
              element={
                user && userRole === 'admin' ? <AdminDashboard /> : <Navigate to="/login" />
              } 
            />
            <Route 
              path="/admin/customers" 
              element={
                user && userRole === 'admin' ? <CustomerManagementPage /> : <Navigate to="/login" />
              } 
            />
            <Route 
              path="/admin/analytics" 
              element={
                user && userRole === 'admin' ? <AdminAnalyticsDashboard /> : <Navigate to="/login" />
              } 
            />
            <Route 
              path="/customer" 
              element={
                user && userRole === 'customer' ? <CustomerDashboard /> : <Navigate to="/login" />
              } 
            />
            <Route 
              path="/customer/data-entry" 
              element={
                user && userRole === 'customer' ? <CustomerDataEntryPage /> : <Navigate to="/login" />
              } 
            />
            <Route 
              path="/customer/data-entry/weekly" 
              element={
                user && userRole === 'customer' ? <CustomerWeeklyDataEntryPage /> : <Navigate to="/login" />
              } 
            />
            <Route 
              path="/customer/data-entry/daily" 
              element={
                user && userRole === 'customer' ? <CustomerDailyDataEntryPage /> : <Navigate to="/login" />
              } 
            />
            <Route
              path="/customer/profile"
              element={
                user && userRole === 'customer' ? <CustomerProfilePage /> : <Navigate to="/login" />
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" />} />
          </Routes>
        </main>
        {user && <AIChatWidget />}
        <Footer showContactLink={!!user} />
      </div>
    </Router>
  )
}

export default App
